export default "__VITE_ASSET__DbUVfwvK__"